import { combineReducers } from 'redux';
import productLookup from './productLookup'

const SearchLookUpReducer = combineReducers({
  productLookup
});

export default SearchLookUpReducer;
